module.exports = __webpack_public_path__ + "static/media/notification-bell.d60cb6bd.svg";